import login from "./login";
import universal from "@/i18n/universal";
import ppt from "./ppt";
import signUp from "./sign-up";
import menu from "@/i18n/menu";
import grade from "@/i18n/grade";
import creation from "@/i18n/creation";
import recharge from "@/i18n/recharge";
import paid from "@/i18n/paid";
import topUp from "@/i18n/top-up";
import valid from "@/i18n/valid";
import home from "@/i18n/home";
import header from "@/i18n/header";
import setting from "@/i18n/setting";
import modal from "@/i18n/modal";
import subject from "@/i18n/subject";
import topicType from "@/i18n/topicType";
import createQuestion from "@/i18n/createQuestion";
import questionEditLeftSide from "@/i18n/questionEditLeftSide";
import startGame from "@/i18n/startGame";
import questionEditRightSide from "@/i18n/questionEditRightSide";
import accountInfo from "@/i18n/accountInfo";
import aiPicture from "@/i18n/aiPicture";
import questionEdit from "@/i18n/questionEdit";
import cropper from "@/i18n/cropper";
import statement from "@/i18n/statement";
import analysis from "@/i18n/analysis";
import world from "@/i18n/world";
import stripePayment from "@/i18n/stripePayment";
import helpPage from "@/i18n/helpPage";
import template from "@/i18n/template";
import activityList from "@/i18n/activityList";
import createCourse from "@/i18n/createCourse";
import talk from "@/i18n/talk";
import report from "@/i18n/report";
import voice from "@/i18n/voice";
import homePage from "@/i18n/homePage";
import meet from "@/i18n/meet";
import classManagement from "@/i18n/classManagement";
import pagination from "@/i18n/pagination";
import studentWork from "@/i18n/studentWork";
import subscribe from "@/i18n/subscribe";

export const zh_HK = {
  login: login.zh_hant,
  universal: universal.zh_hant,
  ppt: ppt.zh_hant,
  signUp: signUp.zh_hant,
  menu: menu.zh_hant,
  grade: grade.zh_hant,
  creation: creation.zh_hant,
  recharge: recharge.zh_hant,
  paid: paid.zh_hant,
  topUp: topUp.zh_hant,
  valid: valid.zh_hant,
  setting: setting.ZH_HK,
  modal: modal.ZH_HK,
  subject: subject.ZH_HK,
  topicType: topicType.ZH_HK,
  createQuestion: createQuestion.ZH_HK,
  questionEditLeftSide: questionEditLeftSide.ZH_HK,
  questionEditRightSide: questionEditRightSide.ZH_HK,
  startGame: startGame.ZH_HK,
  accountInfo: accountInfo.ZH_HK,
  home: home.ZH_HK,
  header: header.ZH_HK,
  aiPicture: aiPicture.ZH_HK,
  questionEdit: questionEdit.ZH_HK,
  cropper: cropper.ZH_HK,
  statement: statement.ZH_HK,
  analysis: analysis.ZH_HK,
  world: world.zh_hant,
  stripePayment: stripePayment.zh_hant,
  helpPage: helpPage.ZH_HK,
  template: template.ZH_HK,
  activityList: activityList.ZH_HK,
  createCourse: createCourse.ZH_HK,
  talk: talk.ZH_HK,
  report: report.ZH_HK,
  voice: voice.ZH_HK,
  homePage: homePage.ZH_HK,
  meet: meet.ZH_HK,
  classManagement: classManagement.ZH_HK,
  pagination: pagination.ZH_HK,
  studentWork: studentWork.ZH_HK,
  subscribe: subscribe.ZH_HK
};

export const en_US = {
  login: login.en,
  universal: universal.en,
  ppt: ppt.en,
  signUp: signUp.en,
  menu: menu.en,
  grade: grade.en,
  creation: creation.en,
  recharge: recharge.en,
  paid: paid.en,
  topUp: topUp.en,
  valid: valid.en,
  home: home.EN,
  header: header.EN,
  setting: setting.EN,
  modal: modal.EN,
  subject: subject.EN,
  topicType: topicType.EN,
  createQuestion: createQuestion.EN,
  questionEditLeftSide: questionEditLeftSide.EN,
  questionEditRightSide: questionEditRightSide.EN,
  startGame: startGame.EN,
  accountInfo: accountInfo.EN,
  aiPicture: aiPicture.EN,
  questionEdit: questionEdit.EN,
  cropper: cropper.EN,
  statement: statement.EN,
  analysis: analysis.EN,
  world: world.en,
  stripePayment: stripePayment.en,
  helpPage: helpPage.EN,
  template: template.EN,
  activityList: activityList.EN,
  createCourse: createCourse.EN,
  talk: talk.EN,
  report: report.EN,
  voice: voice.EN,
  homePage: homePage.EN,
  meet: meet.EN,
  classManagement: classManagement.EN,
  pagination: pagination.EN,
  studentWork: studentWork.EN,
  subscribe: subscribe.EN
};

export const es_ES = {
  menu: menu.es,
  valid: valid.es,
  universal: universal.es,
  recharge: recharge.es,
  subject: subject.es,
  ppt: ppt.es,
  modal: modal.es,
  topicType: topicType.es,
  signUp: signUp.es,
  header: header.es,
  login: login.es,
  template: template.es,
  helpPage: helpPage.es,
  stripePayment: stripePayment.es,
  questionEditRightSide: questionEditRightSide.es,
  questionEditLeftSide: questionEditLeftSide.es,
  questionEdit: questionEdit.es,
  home: home.es,
  world: world.es,
  startGame: startGame.es,
  accountInfo: accountInfo.es,
  aiPicture: aiPicture.es,
  topUp: topUp.es,
  createQuestion: createQuestion.es,
  cropper: cropper.es,
  activityList: activityList.es,
  createCourse: createCourse.es,
  talk: talk.es,
  report: report.es,
  voice: voice.es,
  homePage: homePage.es,
  grade: grade.es,
  analysis: analysis.es,
  meet: meet.es,
  classManagement: classManagement.es,
  pagination: pagination.es,
  studentWork: studentWork.es,
  subscribe: subscribe.es
};

export const zh_CN = {
  login: login.zh_cn,
  universal: universal.zh_cn,
  ppt: ppt.zh_cn,
  signUp: signUp.zh_cn,
  menu: menu.zh_cn,
  grade: grade.zh_cn,
  creation: creation.zh_cn,
  recharge: recharge.zh_cn,
  paid: paid.zh_cn,
  topUp: topUp.zh_cn,
  valid: valid.zh_cn,
  setting: setting.zh_cn,
  modal: modal.zh_cn,
  subject: subject.zh_cn,
  topicType: topicType.zh_cn,
  createQuestion: createQuestion.zh_cn,
  questionEditLeftSide: questionEditLeftSide.zh_cn,
  questionEditRightSide: questionEditRightSide.zh_cn,
  startGame: startGame.zh_cn,
  accountInfo: accountInfo.zh_cn,
  home: home.zh_cn,
  header: header.zh_cn,
  aiPicture: aiPicture.zh_cn,
  questionEdit: questionEdit.zh_cn,
  cropper: cropper.zh_cn,
  statement: statement.zh_cn,
  analysis: analysis.zh_cn,
  world: world.zh_cn,
  stripePayment: stripePayment.zh_cn,
  helpPage: helpPage.zh_cn,
  template: template.zh_cn,
  activityList: activityList.zh_cn,
  createCourse: createCourse.zh_cn,
  talk: talk.zh_cn,
  report: report.zh_cn,
  homePage: homePage.zh_cn,
  voice: voice.ZH_CN,
  meet: meet.zh_cn,
  classManagement: classManagement.ZH_CN,
  pagination: pagination.ZH_CN,
  studentWork: studentWork.ZH_CN,
  subscribe: subscribe.ZH_CN
};
